export default {
  'background-color': '#f0f2f5',
  'color': '#262626',
  'padding': '8px 0'
}
